import { contactContent } from '@/mocks/homeData';

export default function ContactSection() {
  return (
    <section id="contact" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-3">
            <i className="ri-mail-send-line"></i>
            <span>联系我们</span>
          </div>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950">
            联系我们
          </h2>
          <p className="mt-2 text-sm text-foreground-500 max-w-lg mx-auto">
            {contactContent.desc}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {contactContent.items.map((item) => (
            <div
              key={item.label}
              className="flex items-center gap-4 p-5 rounded-xl bg-background-50 hover:bg-background-200 transition-colors"
            >
              <div className="w-11 h-11 rounded-xl bg-primary-100 flex items-center justify-center flex-shrink-0">
                <i className={`${item.icon} text-primary-600 text-lg`}></i>
              </div>
              <div className="min-w-0">
                <div className="text-xs text-foreground-500 mb-0.5">{item.label}</div>
                <div className="text-sm font-semibold text-foreground-900 break-all">
                  {item.value}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}